import I18n from "@/i18n";
import Members from "@/Member";

const Member = {
    setupTranslation: function () {
        const text = {
            "firstname": "Prénom",
            "lastname": "Nom",
            "email": "Courriel",
            "phone1": "Téléphone",
            "phone2": "Autre téléphone",
            "address": "Adresse",
            "pronoun": "Pronom",
            "rebatePercentage": "Pourcentage de rabais sur tous items",
            pronounHint: "elle, il, iel etc",
            password: "Mot de passe"
        };
        I18n.i18next.addResources("fr", "member", text);
        I18n.i18next.addResources("en", "member", text);
    },
    format: function (member, buyGroup) {
        member.fullname = member.firstname + " " + member.lastname;
        if (buyGroup) {
            const subscriptionToBuyGroup = Members.subscriptionToBuyGroupId(member, buyGroup.id);
            member.isAdminOfBuyGroup = subscriptionToBuyGroup.isAdmin;
            if (subscriptionToBuyGroup.isAdmin) {
                member.status = "admin"
            }
            member.rebates = subscriptionToBuyGroup.rebates;
        }
        return member;
    },
    isApproved: function (member) {
        if (member === null || member === undefined) {
            return false;
        }
        return member.status !== "pending" && member.status !== "disabled";
    },
    sortAlphabetically: function (members) {
        return members.sort(Member.alphabeticalSorter);
    },
    alphabeticalSorter: function (a, b) {
        const aFullname = a.firstname + " " + b.lastname
        const bFullname = b.firstname + " " + b.lastname
        return aFullname.localeCompare(bFullname);
    },
    isMemberOfBuyGroup: function (member, buyGroup) {
        if (member === null || member === undefined) {
            return false;
        }
        if (buyGroup === null || buyGroup === undefined) {
            return false;
        }
        return member.BuyGroups.some((buyGroupMember) => {
            return buyGroupMember.id === buyGroup.id;
        });
    },
    isAdminOfBuyGroup: function (member, buyGroupId) {
        return member.BuyGroups.some((buyGroup) => {
            return buyGroup.id === buyGroupId && buyGroup.MembersBuyGroups.isAdmin;
        });
    },
    subscriptionToBuyGroupId: function (member, buyGroupId) {
        const buyGroup = Member.getBuyGroup(member, buyGroupId);
        return Member.formatSubscriptionToBuyGroup(
            buyGroup.MembersBuyGroups
        )
    },
    getBuyGroup: function (member, buyGroupId) {
        return member.BuyGroups.find((buyGroup) => {
            return buyGroup.id === buyGroupId;
        })
    },
    calculateSalePercentageAfterRebate: function (rebates, buyGroupSalePercentage) {
        return Math.max(0, buyGroupSalePercentage - rebates.percentage.number);
    },
    formatSubscriptionToBuyGroup: function (subscription) {
        if (subscription.rebates === null || subscription.rebates === undefined) {
            subscription.rebates = {
                percentage: {
                    number: 0
                }
            }
        }
        return subscription;
    }
}
export default Member;
